import { render, staticRenderFns } from "./BatchdetailReportDetail.vue?vue&type=template&id=7f3ab4e8"
import script from "./BatchdetailReportDetail.vue?vue&type=script&lang=js"
export * from "./BatchdetailReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports